import { Injectable } from '@angular/core';
import { forkJoin, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CommonApi } from './api/common.api';
import { CommonService } from './common.service';
import { environment } from 'src/environments/environment';
import { ApiUrls } from 'src/app/config/constants';

@Injectable({
  providedIn: 'root'
})
export class OnboardService {

  shopAdded: any;

  constructor(
    private commonService: CommonService,
    private commonApi: CommonApi,
  ) { }

  /* Add New Catalog */
  addNewCatalogDetails(body: any, shopid: any) {
    return this.commonApi.postData(ApiUrls.catelog + shopid, body).pipe(catchError((err) => this.errorHandler(err)));

    // return forkJoin({isCatalog: this.commonApi.addNewCatalog(body, shopid)}).pipe(
    //   catchError((err) => this.errorHandler(err)),
    //   map(({ isCatalog }) => ({
    //     isCatalog,
    //   }))
    // );
  }

  addNewShopDetails(body: any, shopId: any) {
    if (shopId === null) {
      return this.commonApi.postData(ApiUrls.addshop, body).pipe(catchError((err) => this.errorHandler(err)));
    } else {
      return this.commonApi.putData(ApiUrls.updateShopDetails + '/' + shopId, body).pipe(catchError((err) => this.errorHandler(err)));
    }
  }

  addShopWorkingTime(shopid: any, body: any) {
    return forkJoin({ isShopTime: this.commonApi.addShopWorkingTime(shopid, body) }).pipe(
      catchError((err) => this.errorHandler(err)),
      map(({ isShopTime }) => ({
        isShopTime,
      }))
    );
  }

  /* ----- For KYC ---- */
  /* get all document URL for KYC */
  getUploadKYCURL(docType: any) {
    return forkJoin({ isKYCURLs: this.commonApi.getUploadKYCURL(docType) }).pipe(
      catchError((err) => this.errorHandler(err)),
      map(({ isKYCURLs }) => ({
        isKYCURLs,
      }))
    );
  }

  /* final form-data upload for KYC */
  addKYCFormDetals(body: any) {
    return forkJoin({ isKYC: this.commonApi.addKYCDetails(body) }).pipe(
      catchError((err) => this.errorHandler(err)),
      map(({ isKYC }) => ({
        isKYC,
      }))
    );
  }

  getKYCDetail() {
    return this.commonApi.getKYCDetails().pipe(catchError((err) => this.errorHandler(err)));
  }

  /* ----- For Bank ---- */
  /* get all document URL for Bank */
  getBankPassbookURL() {
    return forkJoin({ isKYCURLs: this.commonApi.getBankPassbookLink() }).pipe(
      catchError((err) => this.errorHandler(err)),
      map(({ isKYCURLs }) => ({
        isKYCURLs,
      }))
    );
  }

  /* final form-data upload for KYC */
  addBankFormDetals(body: any) {
    return forkJoin({ isBank: this.commonApi.addBankDetails(body) }).pipe(
      catchError((err) => this.errorHandler(err)),
      map(({ isBank }) => ({
        isBank,
      }))
    );
  }

  addGstNo(body: any, shopId: any) {
    return this.commonApi.postData(`${ApiUrls.addshop}/${shopId}/gst`, body).pipe(catchError((err) => this.errorHandler(err)));
  }

  getShopDetails(shopId: any) {
    return this.commonApi.getData(`${ApiUrls.getShopDetails}/${shopId}`).pipe(catchError((err) => this.errorHandler(err)));
  }

  getShopOwnerDetails(shopId: any) {
    return this.commonApi.getData(`${ApiUrls.getShopOwnerDetails}/${shopId}`).pipe(catchError((err) => this.errorHandler(err)));
  }

  getGstDetails(shopId: any) {
    return this.commonApi.getData(`${ApiUrls.getGstDetails}/${shopId}/gst`).pipe(catchError((err) => this.errorHandler(err)));
  }

  private errorHandler(err: any) {
    if (err.error.length >= 1) {
      this.commonService.danger(err.error[0].message);
    } else {
      this.commonService.danger(err.error.error.message);
    }
    return throwError(err);
  }
}
